export default {
    s3: {
        REGION: "EU(Frankfurt)",
        BUCKET: "movemandu-bucket"
    },
    apiGateway: {
        REGION: "",
        URL: ""
    },
    cognito: {
        REGION: "us-east-2",
        USER_POOL_ID: "us-east-2_8Ymij3biV",
        APP_CLIENT_ID: "7k9tj70tuopomp1hhlmt6g5nj2",
        IDENTITY_POOL_ID: "us-east-2:a199655e-58a9-4904-8fe7-cd6cd036c75f"
    }
};


// WEBPACK FOOTER //
// ./src/config.js